import styled from "styled-components";
import media from "constants/media";
import { Info } from "../summary/Summary.styled";

export const StickyStyled = styled.div`
    position: fixed;
    right: 0;
    bottom: 0;
    z-index: 9;

    display: flex;
    width: 100%;
    margin-top: 25px;
    padding: 20px 0;

    background-color: var(--color-white);
    box-shadow: 3px -3px 7px 0 rgba(0, 23, 75, 0.05);

    ${media.mdUp`
        ${Info} {
            width: 55%;
        }
    `};
`;

export const UspsContainer = styled.div`
    display: none;
    padding-left: 12px;

    transition: all 0.3s ease-in-out;

    svg {
        width: 15px;
        height: 12px;
    }

    span {
        padding-left: 12px;
    }

    ${media.mdUp`
        display: flex;
        width: 45%;
        align-items: center;
    `}
`;
